import PropsTypes from "prop-types";

const operatorExportOrderProps = {
  type: {
    isOpenModal: PropsTypes.bool.isRequired,
    setIsOpenModal: PropsTypes.func.isRequired,
  },
};

export default operatorExportOrderProps;
